
import navigator from '@/models/navigations.js'

const getDefaultState = () => {
  return {
    navigatorIndex: navigator.selectIndex()
  }
}

const state = getDefaultState()

const mutations = {
  SET_NAVIGATORINDEX: (state, index) => {
    state.navigatorIndex = index
  }
}

const actions = {
  setNavigatorIndex({ commit }, index) {
    console.log(index)
    navigator.setIndex(index)
    commit('SET_NAVIGATORINDEX', index)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

